import React from 'react'
import NavLinkOrA from "./NavLinkOrA"

class MobHeader extends React.Component {
  constructor(props) {
    super(props)
    this.toggleMenu = this.toggleMenu.bind(this)
  }

  toggleMenu() {
    this.props.toggleMenu()
  }
  render() {
    return (
      <div className="mh mobonly">
        <NavLinkOrA is404={this.props.is404} to="/"><img src="/img/logo/logo.svg" className="mh__logo__90" alt="Кінотеатр Жовтень" /></NavLinkOrA>
        <p className="mh__hamburger" onClick={() => this.toggleMenu() }>
          <span className="top"></span><span className="middle"></span><span className="bottom"></span>
        </p>
      </div>
    )
  }
}

export default MobHeader


// WEBPACK FOOTER //
// ./src/components/snippets/MobHeader.jsx